module.exports = __webpack_public_path__ + "img/settings.8a7b0b5e.svg";